import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';

/** Optimizely flag → Nexus `?feature-toggle=` value that admits that source system's policies. */
const POLICIES_FEATURE_TOGGLES: ReadonlyArray<{ flag: string; apiToggle: string }> = [
  { flag: 'cl_policies', apiToggle: 'includeClFusion' },
  { flag: 'includeclmajesco', apiToggle: 'includeClMajesco' },
  { flag: 'pl_phoenix_umbrella_policy', apiToggle: 'includeConnectUmbrella' },
  { flag: 'includeclfarmranch', apiToggle: 'includeClFarmRanch' }
];

/**
 * The `?feature-toggle=` values Nexus needs to include the same source systems in its policy
 * lookup as `/policies`. Any endpoint that decides from the customer's policies (e.g.
 * `/quick-links`) must send the same list, or it judges a smaller portfolio than the page shows.
 */
export function getPoliciesFeatureToggles(featureFlagService: FeatureFlagService): string[] {
  return POLICIES_FEATURE_TOGGLES.filter(({ flag }) => featureFlagService.isEnabled(flag)).map(
    ({ apiToggle }) => apiToggle
  );
}
